import BsFileRichtext from '@meronex/icons/bs/BsFileRichtext';
import icon from './StyledIcon';
export default icon(BsFileRichtext);
